"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onKeyPressField = exports.getDecimalCount = void 0;
var _StandardInput = require("../components/atoms/StandardInput/index.js");
const isCharacter = charCode => {
  return charCode >= 65 && charCode <= 90 || charCode >= 97 && charCode <= 122;
};
const isNumber = charCode => {
  return charCode >= 48 && charCode <= 57;
};
const onKeyPressField = (event, type) => {
  const charCode = event.which || event.charCode;
  const value = event?.tartget?.value || '';
  if (type === _StandardInput.AcceptType.text && !isCharacter(charCode)) {
    event.preventDefault();
  } else if (type === _StandardInput.AcceptType.number && !isNumber(charCode)) {
    event.preventDefault();
  } else if (type === _StandardInput.AcceptType.number && event.target.value.length > 15) {
    event.preventDefault();
  } else if (type === _StandardInput.AcceptType.number && event.key === 'e') {
    event.preventDefault();
  }
};

// export const limitDecimalPrecision = (numberStr, decimalLimit) => {
// 	try {
// 		const match = numberStr.match(/^(\d+\.?\d*)$/);
// 		if (match) {
// 			const integerPart = match[1].split('.')[0];
// 			const decimalPart = match[1].split('.')[1] || '';

// 			if (decimalPart.length > decimalLimit) {
// 				const limitedNumber = `${integerPart}.${decimalPart.slice(0, decimalLimit)}`;
// 				return limitedNumber;
// 			} else {
// 				return numberStr;
// 			}
// 		} else {
// 			// If parsing fails, return the original input
// 			return numberStr;
// 		}
// 	} catch (error) {
// 		// Handle any other unexpected errors
// 		console.error('Error:', error);
// 		return numberStr || '';
// 	}
// };
exports.onKeyPressField = onKeyPressField;
const getDecimalCount = numberStr => {
  const match = numberStr.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match) {
    // No decimal found
    return 0;
  }
  // Extract decimal part and return its length
  const decimalPart = match[1];
  return decimalPart ? decimalPart.length : 0;
};
exports.getDecimalCount = getDecimalCount;